const GAMMA = 1.4;

export function toKw(power, unit) {
  if (unit === 'kw') return power;
  if (unit === 'w') return power / 1000;
  if (unit === 'hp') return power * 0.74569987158227;
  throw new Error(`Unknown power unit: ${unit}`);
}

export function toM3Min(flow, unit) {
  if (unit === 'm3min') return flow;
  if (unit === 'm3h') return flow / 60;
  if (unit === 'lpm') return flow / 1000;
  if (unit === 'lps') return flow * 0.06;
  if (unit === 'cfm') return flow * 0.028316846592;
  throw new Error(`Unknown flow unit: ${unit}`);
}

export function toBarGauge(pressure, unit) {
  if (unit === 'bar') return pressure;
  if (unit === 'psi') return pressure / 14.503773773;
  if (unit === 'kpa') return pressure / 100;
  throw new Error(`Unknown pressure unit: ${unit}`);
}

export function isentropicSpecificPowerKwPerM3Min(dischargeBarG, inletBarA = 1.01325, stages = 1) {
  const p1 = inletBarA * 1e5;
  const p2 = p1 + dischargeBarG * 1e5;
  if (p1 <= 0 || p2 <= p1) return null;

  const ratio = p2 / p1;
  const stageRatio = stages > 1 ? Math.pow(ratio, 1 / stages) : ratio;
  const exponent = (GAMMA - 1) / GAMMA;
  const stageWork = (GAMMA / (GAMMA - 1)) * p1 * (Math.pow(stageRatio, exponent) - 1);
  const work = stageWork * stages;
  return work / 60000;
}

export function specificPowerFromMeasured(powerKw, fadM3Min) {
  if (powerKw == null || fadM3Min == null || fadM3Min <= 0 || powerKw < 0) return null;

  const kwPerM3Min = powerKw / fadM3Min;
  const cfm = fadM3Min / 0.028316846592;
  const kwPer100Cfm = (powerKw * 100) / cfm;
  const kwhPerM3 = kwPerM3Min / 60;

  return { kwPerM3Min, kwPer100Cfm, kwhPerM3, cfm };
}

export function rateEfficiency(actualKwPerM3Min, theoreticalKwPerM3Min) {
  if (!actualKwPerM3Min || !theoreticalKwPerM3Min) return null;
  const efficiency = (theoreticalKwPerM3Min / actualKwPerM3Min) * 100;
  let label = 'Below average';
  let color = 'error';
  if (efficiency >= 80) {
    label = 'Excellent';
    color = 'success';
  } else if (efficiency >= 70) {
    label = 'Good';
    color = 'success';
  } else if (efficiency >= 60) {
    label = 'Average';
    color = 'warning';
  }
  return { efficiency, label, color };
}
